<template>
  <!--新增对话框-->
  <el-dialog
    title="尾款补款通知"
    :visible.sync="dialogVisible"
    width="600px"
    :close-on-click-modal="false"
    append-to-body
    :before-close="handleClose"
  >
    <el-form ref="editForm" label-width="100px" class="demo-editForm">
      <el-form-item label="选择角色">
        <el-checkbox
          v-for="item in cartonsNumberList"
          :key="item.cartonsGoodsId"
          :label="item.goodsName"
          v-model="item.checked"
        >
        </el-checkbox>
      </el-form-item>
      <el-form-item align="center">
        <el-button type="primary" @click="submitForm('editForm')"
          >保存</el-button
        >
        <el-button @click="resetForm('editForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
export default {
  name: "BalancePayment",
  data() {
    return {
      cartonsNumberList: [],
      dialogVisible: false,
    };
  },
  methods: {
    getNotStoreGoodsCartonsNumber(id) {
      this.$axios
        .post("/admin/cartonsGoods/getSingerCartonsGoods", { storeGoodsId: id })
        .then((res) => {
          this.cartonsNumberList = res.data;
        });
    },
    resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.cartonsNumberList = [];
    },
    handleClose() {
      this.resetForm("editForm");
    },
    submitForm(formName) {
      var ids = [];
      this.cartonsNumberList.forEach((item) => {
        if (item.checked) {
          ids.push(item.cartonsGoodsId);
        }
      });
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
        .post("/admin/singleStoreGoods/balancePayment", { idList: ids })
        .then((res) => {
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {
              this.$emit("refreshDataList");
            },
          });
          loading.close();
          this.dialogVisible = false;
          this.resetForm(formName);
        });
    },
    init(id) {
      this.dialogVisible = true;
      this.getNotStoreGoodsCartonsNumber(id);
    },
  },
};
</script>

<style scoped></style>
